import { faUserSecret } from "@fortawesome/free-solid-svg-icons"
import { AdditionalCard, AdditionalCardText } from "../styled/Card.style"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Vspace } from "../styled/Separators.style"

/* istanbul ignore next */
const FotoPrivacyWarning = () => {
    return (
        <>
            <AdditionalCard>
                <AdditionalCardText>
                    <FontAwesomeIcon icon={faUserSecret} />
                    Per privacy è vietato fotografare persone.
                </AdditionalCardText>
            </AdditionalCard>
            <Vspace qty={1.5}></Vspace>
        </>
    )
}

export default FotoPrivacyWarning